/* @flow */

import { callLiferayEndpoint } from './index';
import utils from './utils';

import type { ProductionType, FindProductionTypeParams } from 'types';

const find = async (params: ?FindProductionTypeParams): Promise<ProductionType[]> => {
  const { broadcastTypeId, usageTypeId } = params || {};
  const response = await callLiferayEndpoint(
    '/protones-portlet.tipologieproduzione/find-by-tipologia-emissione-and-tipologia-utilizzo',
    {
      tipologiaEmissioneId: broadcastTypeId || 0,
      tipologiaUtilizzoId: usageTypeId || 0,
    }
  );
  return response.map(utils.toProductionType);
};

export default {
  find,
};
